import posthog from 'posthog-js';

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: 'https://e.docuwhy.com',
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
  person_profiles: 'identified_only',
  capture_exceptions: true,
  debug: process.env.NODE_ENV === 'development',
});
